import axios from "axios";

const baseURL = "/api/v1/users";

const fetch = (
  currentPage = 1,
  pageSize = 10,
  search = "",
  filterBy = "",
  filterValue = ""
) =>
  axios.get(baseURL, {
    params: {
      page: currentPage,
      per_page: pageSize,
      search: search,
      filter_by: filterBy,
      filter_value: filterValue,
    },
  });

const show = id => axios.get(`${baseURL}/${id}`);


const getCurrentUser = () => axios.get(`${baseURL}/get_current_user`);

const usersApi = { fetch, show, getCurrentUser };

export default usersApi;
